import React from "react";

export const FidelityContext = React.createContext({
    doDetachCompany: null,
    parent: null,
});